// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_4eK4c","g-wheel-warp":"g-wheel-warp","g-pointer":"g-pointer"};